import React from 'react';
import { Alert, Button } from 'reactstrap';

const ErrorContainer = (props) => {
    const getErrorMessage = (error) => {
        if (error instanceof Error) {
            return error.message;
        }
        if (typeof error === "object" && error?.Message) {
            return error.Message;
        }
        if (typeof error === "string") {
            return error;
        }
        return "An unexpected error occurred";
    };
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-8">
                    <Alert style={{margin: '0px 10px 10px 10px'}} color="danger" fade={false}>{getErrorMessage(props.error)}
                    </Alert>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    <Button
                    onClick={() => {window.location = `https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/${props.changeId}`}}
                    style={{margin: '0px 10px 0px 10px'}}
                    color={"success"}
                    block
                    >
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ErrorContainer;